import { ORDER_METHODS, PaymentMethods } from '../../../../../../services/exports/Constants';

export default {
  title: 'Modes de paiement',
  fields: {
    hidden_payment_methods: {
      label: 'Modes de paiement masqués',
    },
    has_online_payments: {
      label: 'Paiements en ligne activés',
    },
    has_paypal_upcharge: {
      label: 'Majoration de 3,5 % pour les transactions PayPal',
    },
    has_cash_payments: {
      label: 'Paiements en espèces activés',
    },
    has_occ_cash_payments: {
      label: 'Paiements en espèces Call Center activés',
    },
    has_in_store_card_payments: {
      label: 'Paiements par carte en magasin activés',
    },
    overwrite_cash_payments_to_invoice: {
      label: 'Libeller les paiements en espèces comme « Facture »',
    },
  },
  payment_methods: {
    [PaymentMethods.CARD]: 'Carte',
    [PaymentMethods.PAYPAL]: 'PayPal',
    [PaymentMethods.APPLE_PAY]: 'Apple Pay',
    [PaymentMethods.GOOGLE_PAY]: 'GPay',
    [PaymentMethods.SOFORT]: 'Sofort',
    [PaymentMethods.IDEAL]: 'iDEAL | Wero',
    [PaymentMethods.BANCONTACT]: 'Bancontact',
    [PaymentMethods.EPS]: 'EPS',
    [PaymentMethods.P24]: 'Przelewy24',
    [PaymentMethods.BLIK]: 'BLIK',
    [PaymentMethods.TWINT]: 'TWINT',
    [PaymentMethods.VENMO]: 'Venmo',
    [PaymentMethods.WERO]: 'Wero',
    [PaymentMethods.KLARNA]: 'Klarna',
    [PaymentMethods.TRUSTLY]: 'Trustly',
    [PaymentMethods.PIX]: 'Pix',
    [PaymentMethods.NUPAY]: 'NuPay',
    [PaymentMethods.GIROPAY]: 'Giropay',
    [PaymentMethods.SEPA_DEBIT]: 'Prélèvement SEPA',
    [PaymentMethods.CASH]: 'Espèces',
    [PaymentMethods.BACS_DEBIT]: 'Prélèvement Bacs',
    [PaymentMethods.PAY_BY_BANK]: 'Paiement par virement',
  },
  order_methods: {
    [ORDER_METHODS.pickup]: 'À emporter',
    [ORDER_METHODS.delivery]: 'Livraison',
    [ORDER_METHODS.room_service]: 'Service en chambre/à table',
  },
  modals: {
    confirmation: {
      title: 'Êtes-vous sûr ?',
      description:
        'Une fois confirmé, les paiements en ligne seront <strong>{{onlineState}}</strong>, les paiements en espèces seront <strong>{{cashState}}</strong>',
    },
  },
  labels: {
    off: 'désactivé',
    on: 'activé',
  },
  buttons: {
    save: 'Enregistrer',
    configure_online_payments: 'Configurer les paiements en ligne',
  },
  toasts: {
    failed_to_save_changes: "Échec de l'enregistrement",
    changes_got_saved: 'Modifications enregistrées',
  },
};
